export default __webpack_public_path__ + "static/media/downloadMan.ff5e411c.svg";